import {
  formatPerformanceVsPeakCompact,
  formatPostsPublishedLabel,
  formatShareOfTotalEngagementCompact,
  OPTIMAL_POSTING_HIGHEST_PERFORMING_LABEL,
} from '../utils/optimalPostingTimesUtils'
import { OPPORTUNITIES_EMPTY_MESSAGE } from '../utils/optimalPostingOpportunities'

const ROW_UNAVAILABLE_MESSAGE = 'Not enough data for this insight.'
const INSIGHTS_ARIA_LABEL = 'Posting time insights'

export const DEFAULT_OPPORTUNITY_ROW_CONFIG = [
  { type: 'best', label: 'BEST OPPORTUNITY', opportunityKey: 'bestPerforming' },
  { type: 'reliable', label: 'MOST RELIABLE', opportunityKey: 'consistentPerformer' },
  { type: 'review', label: 'NEEDS REVIEW', opportunityKey: 'improvementOpportunity' },
]

export const DAILY_OPPORTUNITY_ROW_CONFIG = [
  { type: 'best', label: 'BEST OPPORTUNITY', opportunityKey: 'bestPerforming' },
  { type: 'reliable', label: 'MOST RELIABLE', opportunityKey: 'consistentPerformer' },
  { type: 'review', label: 'NEEDS REVIEW', opportunityKey: 'improvementOpportunity' },
]

function InsightCard({ type, label, opportunity }) {
  const isBestRow = type === 'best'
  const postsLine = opportunity ? formatPostsPublishedLabel(opportunity.postCount) : null
  const peakLine = formatPerformanceVsPeakCompact(opportunity?.performanceVsPeak)
  const shareLine = formatShareOfTotalEngagementCompact(opportunity?.shareOfTotalEngagement)
  const showHighestPerforming = isBestRow && opportunity?.isHighestPerforming
  const hasMetadata = Boolean(postsLine || (shareLine && shareLine !== 'Not available'))

  return (
    <div className="optimalPostingInsightSignal">
      <div className="optimalPostingInsightSignalContent">
        <span className="optimalPostingInsightSignalTitle">{label}</span>
        {opportunity?.hasValidPosts !== false && opportunity ? (
          <>
            {opportunity.timeWindow ? (
              <span className="optimalPostingInsightSignalWindow dashboard-tabular-nums">
                {opportunity.timeWindow}
              </span>
            ) : null}
            {showHighestPerforming ? (
              <span className="optimalPostingInsightSignalPrimary">
                {OPTIMAL_POSTING_HIGHEST_PERFORMING_LABEL}
              </span>
            ) : peakLine && peakLine !== 'Not available' ? (
              <span className="optimalPostingInsightSignalPrimary dashboard-tabular-nums">{peakLine}</span>
            ) : null}
            {hasMetadata ? (
              <div className="optimalPostingInsightSignalMetadata">
                {postsLine ? (
                  <span className="optimalPostingInsightSignalMeta dashboard-tabular-nums">{postsLine}</span>
                ) : null}
                {shareLine && shareLine !== 'Not available' ? (
                  <span className="optimalPostingInsightSignalMeta dashboard-tabular-nums">{shareLine}</span>
                ) : null}
              </div>
            ) : null}
          </>
        ) : (
          <span className="optimalPostingInsightSignalMeta">{ROW_UNAVAILABLE_MESSAGE}</span>
        )}
      </div>
    </div>
  )
}

export default function OptimalPostingTopOpportunities({
  opportunities,
  rowConfig = DEFAULT_OPPORTUNITY_ROW_CONFIG,
}) {
  if (!opportunities?.hasAny) {
    return (
      <section className="optimalPostingOpportunities" aria-label={INSIGHTS_ARIA_LABEL}>
        <div
          className="optimalPostingInsightSignals"
          role="group"
          aria-label={INSIGHTS_ARIA_LABEL}
        >
          <div className="optimalPostingInsightSignal optimalPostingInsightSignal--empty">
            <div className="optimalPostingInsightSignalContent">
              <span className="optimalPostingInsightSignalMeta">{OPPORTUNITIES_EMPTY_MESSAGE}</span>
            </div>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="optimalPostingOpportunities" aria-label={INSIGHTS_ARIA_LABEL}>
      <div
        className="optimalPostingInsightSignals"
        role="group"
        aria-label={INSIGHTS_ARIA_LABEL}
      >
        {rowConfig.map(({ type, label, opportunityKey }) => (
          <InsightCard
            key={type}
            type={type}
            label={label}
            opportunity={opportunities[opportunityKey]}
          />
        ))}
      </div>
    </section>
  )
}
